import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { setAnalyticsAdapter } from '@/lib/analytics';
import { diagnostics, installBrowserDiagnostics } from '@/lib/diagnostics';
import './index.css';

setAnalyticsAdapter({
  track(event) {
    if (import.meta.env.DEV) {
      console.info('[analytics]', event.name, event.properties ?? {});
    }
  },
});

const stopDiagnostics = installBrowserDiagnostics();
if (import.meta.hot) import.meta.hot.dispose(stopDiagnostics);

createRoot(document.getElementById('root')!, {
  onUncaughtError(error) {
    console.error('[App] Uncaught render failure', error);
    diagnostics.report('browser_error', error);
  },
}).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
